import styled from 'styled-components';
import { ModalDialogMixin } from '../../mixins/components/ModalDialogMixin';
import { Modal } from '../Modal/Modal';
export var StyledModalDialog = /*#__PURE__*/styled(Modal).withConfig({
  displayName: "StyledModalDialog",
  componentId: "c11n-8-107-0__sc-13vcfw8-0"
})(["", ""], ModalDialogMixin);